import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Box,
    Collapse,
    FormControl,
    IconButton,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";
import { resolveVideoPreview, setOnProgressCallback, uploadVideoToCloudflareStream } from "../../../network/cloudflare_stream_service/CloudflareStream_api_callback";
import { generatePublicUrlForFileInAWSS3Bucket, getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket'
import { getMediaDimensionsAndRatio, updateStateObjectData } from "../../../utility/Common";
import ProgressModal from "../../../utility/ProgressModal";
import MediaUploadDialog from "./MediaUploadDialog";

const MultimediaSection = ({ editableEntityData, setEditableEntityData, title, mediaType, data, ratioOptions = [], onAdd, onDelete, onItemClick, getMultiMediaByEntityId, editableEntityMultimediaData }) => {

    const [mediaUpload, setMediaUpload] = useState(false);
    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [loader, setLoader] = useState(false);

    const [expanded, setExpanded] = useState(true);
    const [ratioFilter, setRatioFilter] = useState("ALL");

    const toggleExpanded = () => setExpanded(!expanded);

    const fileInputRef = useRef();

    const filteredItems = (ratioFilter === "ALL" ? data : data.filter((item) => item.aspectRatio === ratioFilter));

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (mediaType === 'video') {
            try {
                setUploading(true);
                setProgress(0);
                setOnProgressCallback((percent) => setProgress(percent));
                const { width, height, mediaType, ratio } = await getMediaDimensionsAndRatio(file);
                const resp = await uploadVideoToCloudflareStream(file);
                const finalUrl = resp?.videoUrl;
                console.log("Cloudflare Stream upload:", finalUrl);
                const videoObj = {
                    mediaType: "video",
                    url: `${finalUrl}`,
                    aspectRatio: `${ratio}`
                }
                const newMultimedia = Array.isArray(editableEntityData?.multimedia) ? [...editableEntityData.multimedia] : [];
                newMultimedia.push(videoObj);
                updateStateObjectData(editableEntityData, setEditableEntityData, "multimedia", newMultimedia)
                e.target.value = null; // reset input
            } catch (err) {
                console.error("Upload failed:", err);
                toast.error(err?.message || `Upload failed for ${file?.name || "file"}`);
            }
            finally {
                setUploading(false);
                setProgress(0);
            }
        }
        else if (mediaType === 'image') {
            try {
                setLoader(true)
                const { width, height, mediaType, ratio } = await getMediaDimensionsAndRatio(file);
                const result = await uploadFileToAWSS3Bucket("entertainment_entity", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("entertainment_entity", result?.key?.split('/').pop());
                //const cleanedPath = fileResult?.url?.pathname.replace(/^\/private/, "");
                const cleanedPath = fileResult?.url?.pathname;
                console.log("Single File AWS fileResult : ", cleanedPath)
                const url = "https://d3oxgt44kg2k0d.cloudfront.net" + cleanedPath
                console.log("Single File AWS url : ", url)
                const imageObj = {
                    mediaType: "image",
                    imageType: "thumbnail",
                    url: `${url}`,
                    aspectRatio: `${ratio}`
                }

                const newMultimedia = Array.isArray(editableEntityData?.multimedia) ? [...editableEntityData.multimedia] : [];
                newMultimedia.push(imageObj);
                updateStateObjectData(editableEntityData, setEditableEntityData, "multimedia", newMultimedia)
                e.target.value = null; // reset input
            }
            catch (err) {
                console.error("Upload failed:", err);
            }
            finally {
                setLoader(false)
            }
        }
        else if (mediaType === 'audio') {
            try {
                setLoader(true)
                const result = await uploadFileToAWSS3Bucket("entertainment_entity", file);
                console.log("Upload AWS result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("entertainment_entity", result?.key?.split('/').pop());
                //const cleanedPath = fileResult?.url?.pathname.replace(/^\/private/, "");
                const cleanedPath = fileResult?.url?.pathname;
                console.log("Single File AWS fileResult : ", cleanedPath)
                const url = "https://d3oxgt44kg2k0d.cloudfront.net" + cleanedPath
                console.log("Single File AWS fileResult : ", url)
                const audioObj = {
                    mediaType: "audio",
                    url: `${url}`,
                }

                const newMultimedia = Array.isArray(editableEntityData?.multimedia) ? [...editableEntityData.multimedia] : [];
                newMultimedia.push(audioObj);
                updateStateObjectData(editableEntityData, setEditableEntityData, "multimedia", newMultimedia)
                e.target.value = null; // reset input
            }
            catch (err) {
                console.error("Upload failed:", err);
            }
            finally {
                setLoader(false)
            }
        };
    }

    return (
        <>
            <Box sx={{ mb: 3 }}>

                {/* Header */}
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1
                }}>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="h6">{title}</Typography>
                        <IconButton onClick={()=>{
                            setMediaUpload(true)
                        }}>
                            <AddCircleOutlineIcon />
                        </IconButton>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept={mediaType === 'image' ? 'image/*' : mediaType === 'video' ? 'video/*' : 'audio/*'}
                            hidden
                            onChange={handleFileChange}
                        />
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        {/* {(mediaType === "video" || mediaType === "image") && (
                            <FormControl size="small">
                                <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Ratio</InputLabel>
                                <Select
                                    label="Ratio"
                                    value={ratioFilter}
                                    onChange={(e) => setRatioFilter(e.target.value)}
                                    sx={GameCssStyles.formFiledStyle_sx2}>
                                    <MenuItem value="ALL">All</MenuItem>
                                    {ratioOptions.map((r) => (
                                        <MenuItem key={r._id} value={r.value} sx={GameCssStyles.menuItemStyle_sx}>{r.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )} */}

                        <IconButton onClick={toggleExpanded}>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>

                    </Box>
                </Box>

                {/* Media Items */}
                <Collapse in={expanded}>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        {filteredItems?.map((item, idx) => (
                            <Box key={idx}
                                sx={{
                                    position: "relative",
                                    cursor: "pointer",
                                    ...(mediaType === 'audio' ? styles.audioItemCard : styles.commonItemCard),
                                    overflow: "hidden"
                                }}
                            >

                                {item.form === "image" && (
                                    <img
                                        src={generatePublicUrlForFileInAWSS3Bucket(item?.url)}
                                        alt="media"
                                        style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none", zIndex: 0 }}
                                    />
                                )}
                                {item.form === "video" &&
                                    (() => {
                                        const preview = resolveVideoPreview(item);
                                        if (preview.type === "cloudflare") {
                                            return (
                                                <iframe
                                                    title={`stream-${idx}`}
                                                    src={preview.embedUrl}
                                                    width="100%"
                                                    height="100%"
                                                    style={{ border: 0, pointerEvents: "none", zIndex: 0 }}
                                                    frameBorder="0"
                                                    allow="fullscreen"
                                                />
                                            );
                                        }
                                        if (preview.type === "vimeo") {
                                            return (
                                                <iframe
                                                    title={`vimeo-${idx}`}
                                                    src={preview.embedUrl}
                                                    width="100%"
                                                    height="100%"
                                                    style={{ border: 0, pointerEvents: "none", zIndex: 0 }}
                                                    frameBorder="0"
                                                    allow="fullscreen"
                                                />
                                            );
                                        }
                                        return (
                                            <video
                                                src={preview.url}
                                                style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none", zIndex: 0 }}
                                            />
                                        );
                                    })()
                                }
                                {item.form === "audio" && (
                                    <audio
                                        src={item?.url}
                                        controls
                                        seeking={false}
                                        style={{ width: "100%", height: "45px", pointerEvents: "none", zIndex: 0 }}
                                    />
                                )}

                                {/* ---------- CLICKABLE OVERLAY (handles open/view) ---------- */}
                                <Box
                                    onClick={() => onItemClick?.(idx, item, mediaType)}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        zIndex: 1,
                                        backgroundColor: "transparent",
                                        pointerEvents: "auto"
                                        // If you want a visible hover effect, uncomment below:
                                        // "&:hover": { backgroundColor: "rgba(0,0,0,0.03)" }
                                    }}
                                />

                                {/* <IconButton
                                    size="small"
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        backgroundColor: "white",
                                        zIndex: 2,
                                        boxShadow: 1,
                                        pointerEvents: "auto"
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(idx, item, mediaType)
                                    }}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton> */}

                            </Box>
                        ))}
                    </Box>
                </Collapse>

            </Box>

            {mediaUpload && <MediaUploadDialog editableEntityData={editableEntityData} open={mediaUpload} onClose={() => {
                getMultiMediaByEntityId(editableEntityData?._id)
                setMediaUpload(false)
                }}/>}
            {(uploading || loader) && <ProgressModal open={uploading || loader} isLoader={loader} progress={progress} title="Uploading File" />}

        </>
    );
};

const styles = {
    commonItemCard: {
        width: 100,
        height: 100,
        border: "1px solid #ccc",
        position: "relative"
    },
    audioItemCard: {
        width: 300,
        height: 'auto',
        position: "relative"
    }
};

export default MultimediaSection;